(function () {
  const root = document.querySelector('[data-hero-rotate]');
  if (!root) return;

  const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
  const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
  if (slides.length < 2) return;

  const intervalMs = Number(root.dataset.interval) || 8000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let index = 0;
  let timer = null;

  function setSlide(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    const slideType = slides[index].dataset.heroSlide;

    slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.classList.toggle('hero--editorial-active', slideType === 'editorial');
  }

  function nextSlide() {
    setSlide(index + 1);
  }

  function startTimer() {
    if (reducedMotion || timer) return;
    timer = window.setInterval(nextSlide, intervalMs);
  }

  function stopTimer() {
    if (!timer) return;
    window.clearInterval(timer);
    timer = null;
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      stopTimer();
      setSlide(i);
      startTimer();
    });
  });

  root.addEventListener('mouseenter', stopTimer);
  root.addEventListener('mouseleave', startTimer);
  root.addEventListener('focusin', stopTimer);
  root.addEventListener('focusout', startTimer);

  setSlide(0);
  startTimer();
})();
